import Home from './routes/Home.svelte';

import NotFound from './routes/NotFound.svelte';
import Test from './routes/Test.svelte';
import {wrap} from 'svelte-spa-router/wrap'

export default {
    '/': Home,
    '/Test': wrap({
        asyncComponent: () => import('./routes/Test.svelte')
    }),
    
    // The catch-all route must always be last
    '*': NotFound
};
